"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.splitMarked = exports.unmark = exports.quoteId = exports.quote = void 0;
/*
 * Customer values quoted inside the tool's own messages.
 *
 * A refusal, a change line, a warning or a compliance problem is the tool's
 * own words: advice an agent should follow. The customer's words, links and
 * names it quotes are data. quote() marks each such value, so the MCP can
 * show the message as the tool's words and only the quoted values inside
 * <untrusted-data> (wrapping the whole message told an agent to ignore the
 * advice in it). Every value that came from the email or the caller is
 * quoted; ids in the editor's own shape go bare (quoteId). unmark() gives
 * plain text for everyone else.
 *
 * Where a message puts quote marks round a value, they go outside the
 * value, as in `no "${quote(key)}"`: the MCP then shows
 * "<untrusted-data>key</untrusted-data>", the same way everywhere.
 */
const OPEN = "\u0002";
const CLOSE = "\u0003";
const MARKS = /[\u0002\u0003]/g;
/** A customer's or caller's value quoted in a message. */
const quote = (value) => `${OPEN}${String(value !== null && value !== void 0 ? value : "").replace(MARKS, "")}${CLOSE}`;
exports.quote = quote;
const EDITOR_ID = /^[\w-]{1,64}$/;
/** An id: bare when it has the editor's shape (letters, digits, - and _), quoted otherwise. */
const quoteId = (id) => (typeof id === "string" && EDITOR_ID.test(id) ? id : (0, exports.quote)(id));
exports.quoteId = quoteId;
/** A marked message as plain text. */
const unmark = (s) => String(s !== null && s !== void 0 ? s : "").replace(MARKS, "");
exports.unmark = unmark;
/** A marked message in parts: the tool's own words, and the quoted values. */
const splitMarked = (s) => {
    const parts = [];
    const re = /\u0002([^\u0002\u0003]*)\u0003/g;
    let last = 0;
    let m;
    const str = String(s !== null && s !== void 0 ? s : "");
    while ((m = re.exec(str))) {
        if (m.index > last)
            parts.push({ text: (0, exports.unmark)(str.slice(last, m.index)), quoted: false });
        parts.push({ text: m[1], quoted: true });
        last = re.lastIndex;
    }
    if (last < str.length)
        parts.push({ text: (0, exports.unmark)(str.slice(last)), quoted: false });
    return parts;
};
exports.splitMarked = splitMarked;
//# sourceMappingURL=marked_text.js.map